import React, {useState, useEffect} from 'react';
import {Link, NavLink} from 'react-router-dom';
import Navbar from './Navbar';
// import FAQAccordion1 from './FAQAccordion1';
// import FAQAccordion2 from './FAQAccordion2';
import '../App.css';
import Container from '@material-ui/core/Container';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import './FAQContent.css';
import Data1 from './Data1.json';
import Data2 from './Data2.json';
import SearchIcon from '@material-ui/icons/Search';



function FAQContent() {
    const [click, setClick] = useState(false);
    return (
        <>
        <div className="tech-container main-container" id="faq-box">
            <title>Job Readiness - FAQs</title>
            <h1 className="sr-only" tabIndex={0}>Job Readiness - FAQs</h1>
            <img src="/images/faqs-banner.jpg" className="banner-img"  alt='faq banner'/>
            <Navbar/> 
        </div>
        <Container id='main'>
            <SimpleTabs/>
        </Container>
        </>
    )
}
export default FAQContent;


// tabs function component

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchTermFirst('');
    setSearchTermSecond('');
  };
  const [searchTermFirst, setSearchTermFirst] = useState('');
  const [filteredData1, setFilteredData1] = useState([]);
  const [searchTermSecond, setSearchTermSecond] = useState('');
  const [filteredData2, setFilteredData2] = useState([]);

  useEffect(() => {
    setFilteredData1(
      Data1.filter((post)=> 
        post.question.toLowerCase().includes(searchTermFirst.toLowerCase()) ||
        post.answer.toLowerCase().includes(searchTermFirst.toLowerCase())
      )
    )
  },[searchTermFirst,Data1])

  useEffect(() => {
    setFilteredData2(
      Data2.filter((post)=> 
        post.question.toLowerCase().includes(searchTermSecond.toLowerCase()) ||
        post.answer.toLowerCase().includes(searchTermSecond.toLowerCase())
      )
    )
  },[searchTermSecond,Data2])

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="FAQs for ASEs" {...a11yProps(0)} />
          <Tab label="FAQs for Mentors/SMEs/Supervisors/DU Leads" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <h2 className="faq-head">Frequently asked questions</h2>
      <TabPanel value={value} index={0}>
            <div className="posts">
              <div className="search-icon">
                <SearchIcon />
                <input type="text" className="search-input" placeholder="Search..." onChange={(event) => {setSearchTermFirst(event.target.value);}} aria-label="Search" />
              </div>
              {
                filteredData1.length === 0 ? <h2 className="not-found">No Results Found</h2> : filteredData1.map(post => {
                  return(
                    <div key={post.id} className="post-box">
                      <img src="/images/question-mark.png" className='question-img' alt="question-mark-icon"/>
                      <h3> {post.question}</h3>
                      <p>{post.answer}</p>
                    </div>
                  )
                })
              }
            </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
          <div className="posts">
              <div className="search-icon">
                <SearchIcon />
                <input type="text" className="search-input"  placeholder="Search..." onChange={(event) => {setSearchTermSecond(event.target.value);}} aria-label="Search" />
              </div>
              {
                filteredData2.length === 0 ? <h2 className="not-found">No Results Found</h2> : filteredData2.map(post => {
                  return(
                    <div key={post.id} className="post-box">
                      <img src="/images/question-mark.png" className='question-img' alt="question-mark-icon"/>
                      <h3> {post.question}</h3>
                      <p>
                        {post.answer}
                        <span>{post.answer2}</span>
                        <span>{post.answer3}</span>
                        <span>{post.answer4}</span>
                        <span>{post.answer5}</span>
                        <span>{post.answer6}</span>
                        <span style={{paddingLeft: "20px"}}>{post.answer7}</span>
                        <span style={{paddingLeft: "20px"}}>{post.answer8}</span>
                        <span style={{paddingLeft: "20px"}}>{post.answer9}</span>
                        <span>{post.answer10}</span>
                        <span>{post.answer11}</span>
                      </p>
                    </div>
                  )
                })
              }
            </div>
      </TabPanel>
    </div>
  );
}





